if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const currentTargetId = event.detail.currentElement.dataset.mediaId;
        const currentRawId = event.detail.currentElement.dataset.mediaRawId;
        const thumbnail =
          (currentRawId && this.elements.thumbnails.querySelector(`[data-media-raw-id="${currentRawId}"]`)) ||
          (currentTargetId && this.elements.thumbnails.querySelector(`[data-target="${currentTargetId}"]`)) ||
          this.elements.thumbnails.querySelector(`[data-target$="-${currentTargetId}"]`);
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        if (!mediaId) return;
        const strId = String(mediaId).trim();
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-raw-id="${strId}"]`) ||
          this.elements.viewer.querySelector(`[data-media-id="${strId}"]`) ||
          this.elements.viewer.querySelector(`[data-media-id$="-${strId}"]`) ||
          this.elements.viewer.querySelector(`[data-media-id*="${strId}"]`);

        if (!activeMedia) {
          return;
        }

        this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        this.preventStickyHeader();

        const sliderList = this.elements.viewer.querySelector('ul.product__media-list') || this.elements.viewer.querySelector('.slider');
        if (sliderList && typeof sliderList.scrollTo === 'function') {
          sliderList.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
        }

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail =
          this.elements.thumbnails.querySelector(`[data-media-raw-id="${strId}"]`) ||
          this.elements.thumbnails.querySelector(`[data-target="${strId}"]`) ||
          this.elements.thumbnails.querySelector(`[data-target$="-${strId}"]`) ||
          this.elements.thumbnails.querySelector(`[data-target*="${strId}"]`);

        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail.dataset && activeThumbnail.dataset.mediaPosition) {
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        const btn = thumbnail.querySelector('button');
        if (btn) btn.setAttribute('aria-current', 'true');

        const thumbSlider =
          this.elements.thumbnails.querySelector('ul.thumbnail-list') ||
          this.elements.thumbnails.querySelector('.slider') ||
          this.elements.thumbnails.slider;

        if (thumbSlider && typeof thumbSlider.scrollTo === 'function') {
          thumbSlider.scrollTo({ left: thumbnail.offsetLeft, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
